import React, { useState, useEffect } from 'react'
import ReactDOM from "react-dom"
import PropTypes from 'prop-types'
import Select from 'react-select'
import Student from '../../../../models/Student'
import Spinner from '../../../Spinner'

const StudentSelect = ({ schoolId, educatorId }) => {
  const [option, setOption] = useState();
  const [students, setStudents] = useState([]);

  useEffect(() => {
    Student
      .where({ enrolled_for_school: [schoolId, educatorId] })
      .per(1000)
      .all()
      .then((res) => {
        const options = res.data.map((e) => ({ label: e.fullName(), value: e.id }))
        setStudents(options)
      })
  }, []);

  const addStudent = (e) => {
    e.preventDefault();

    if (!option) return;
    const filteredStudents = students.filter((student) => student.value !== option.value);
    setStudents(filteredStudents)
    setOption(null)
    ReactDOM.render(<Spinner color="blue" />, $('#students-composite')[0] )

    $.ajax({
      url: `/schools/${schoolId}/add_student.js`,
      data: { student_id: option.value, educator_id: educatorId },
      type: 'POST',
      dataType: 'script',
    })
  }

  return (
    <>
    <div className='col-xs-9'>
      <Select
        options={students}
        value={option}
        onChange={(e) => { setOption(e) }}
      />
    </div>

    <div className='col-xs-3'>
      <button onClick={addStudent} className="btn btn-primary">Add {educatorId === 'staff' ? 'Staff' : 'Student'}</button>
    </div>
    </>
  )
}

StudentSelect.propTypes = {
  name: PropTypes.string,
  selectedValue: PropTypes.object,
  valueField: PropTypes.string,
  extraFields: PropTypes.array,
  placeholder: PropTypes.string,
}

StudentSelect.defaultProps = {
  name: null,
  selectedValue: null,
  valueField: 'name',
  extraFields: [],
  placeholder: 'Search All',
}

export default StudentSelect
